"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),t=require("prop-types");function r(e){return e&&e.__esModule?e:{default:e}}var u=r(e),a=r(t);function n({date:e,onClickWeekNumber:t,weekNumber:r}){const a={className:"react-calendar__tile",style:{flexGrow:1}},n=u.default.createElement("span",null,r);return t?u.default.createElement("button",Object.assign({},a,{onClick:u=>t(r,e,u),type:"button"}),n):u.default.createElement("div",Object.assign({},a),n)}n.propTypes={date:a.default.instanceOf(Date).isRequired,onClickWeekNumber:a.default.func,weekNumber:a.default.node.isRequired},exports.default=n;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/cjs/components/ReactCalendar/MonthView/WeekNumber.js
// module id = 862
// module chunks = 0